import { render } from "./table-detail.vue?vue&type=template&id=361582a2&scoped=true&ts=true"
import script from "./table-detail.vue?vue&type=script&lang=ts"
export * from "./table-detail.vue?vue&type=script&lang=ts"

import "./table-detail.vue?vue&type=style&index=0&id=361582a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361582a2"]])

export default __exports__